import { render, staticRenderFns } from "./CourseLocationInfo.vue?vue&type=template&id=e65b2c8a&"
import script from "./CourseLocationInfo.vue?vue&type=script&lang=ts&"
export * from "./CourseLocationInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports